/**
 * Shared rule for how a single auth control reacts to the in-flight sign-in.
 *
 * The four auth forms (`auth/auth-popup-form/LoginForm`,
 * `auth/auth-popup-form/SignupForm`, `redeem_coupon/SigninForm`,
 * `redeem_coupon/SignupForm`) are duplicate copies of the same UI with
 * different markup, so their JSX cannot be shared without a much larger
 * refactor than this fix warrants (design.md D2). The *rule* below is shared
 * instead, so "which button spins" and "when is a button disabled" are defined
 * once rather than copy-pasted four times.
 *
 * Every control is disabled while any one of them is running: two concurrent
 * `signInWithPopup` calls are a real failure mode, since popup blockers
 * suppress the second window.
 *
 * @param {'facebook'|'google'|'apple'|'email'|null} authPending - The control
 *   currently in flight, from `state.common.authPending`.
 * @param {'facebook'|'google'|'apple'|'email'} control - The control being rendered.
 * @returns {{pending: boolean, disabled: boolean}} `pending` marks the one
 *   pressed control that shows a spinner; `disabled` is true for all controls
 *   while any is running.
 */
export function authControlState(authPending, control) {
    return {
        pending: authPending === control,
        disabled: Boolean(authPending)
    };
}

export default authControlState;
